
import {Component, Vue, Watch} from 'vue-property-decorator';
import stores from '../../stores';

@Component({
  components: {},
})

export default class DeleteFolder extends Vue {
  /**
   * Fired when this module is created
   */
  created() {
    this.delete();
  }

  delete() {
    return stores.Folder.deleteFolders(Number(this.$route.params.folderId))
      .then(() => {
        this.$router.push({name: 'media.folder', params: {folderId: '1'}});
      })
      .catch((reason: any) => {
        console.error('Could not delete', reason);
      });
  }
}
